/**
 * The script launches the application by bootstrapping its root module via "ApplicationLoaderService".
 * Because the application runs directly in the browser, "ApplicationLoaderService" imports the "platformBrowserDynamic" function.
 * It initializes the platform and then uses it to bootstrap "AppModule".
 */

import { enableProdMode } from "@angular/core";

import { ApplicationLoaderService } from "./app/shared-library/services/environment/application-loader.service";

if (process.env.ENV === "production") {
    enableProdMode();
}

const appLoaderService = ApplicationLoaderService.instance();

appLoaderService.boot();
appLoaderService.onReboot().subscribe(() => appLoaderService.boot());
